<div class="fund-bg">
    <span class="fund-heading">
      <strong>Let's Start Investing</strong>
    </span>
    <div class="fund-info-body">
      <span class="fund-info">
        Allocate your funds across investment options
        <br/>
        based on <strong>Minimum Holding Period (MHP)</strong> and 
        <strong>Interest Rate</strong>. Click here to 
        <strong><a href="/faq?selectedTab=FINZY_FLEX" target="_blank" class="info-underline">Know more</a></strong> 
      </span>
      <br/>
      <br/>
      <span class="fund-info" style="font-size: 14px;">
        Minimum investment amount is ₹<strong *ngIf="!lenderBasicInfo.portfolioPresent">{{initialFundAllocationMinAmt}}</strong> <strong *ngIf="lenderBasicInfo.portfolioPresent">{{postFundAllocationMinAmt}}</strong>
        and it should be in multiples of ₹<strong>1,000</strong> there on
      </span>
      <div class="wallet-details">
        <div class="wallet-balance">
          <div class="amt-avail">
            <span class="wallet-txt-info">Amount available to invest: &nbsp; </span>
            <div style="height: 18px;">
              <app-tooltip placement="bottom">
                <i class="infoIcon material-icons info-icon" trigger>info_outline</i>
                <div content style="width: 70vw; max-width: 300px">
                  <span>
                    This is your current wallet balance available for investing.
                    Click on <strong>Add Money</strong> to add funds to your investment wallet
                  </span>
                </div>
              </app-tooltip>
              &nbsp;
              &nbsp;
            </div>
          </div>
          <span [ngClass]="(this.remainingWalletBalance < 0) ? 'text-red': ''" class="wallet-amt">
            <app-indian-currency-formatter
              [amount]="getAmountAvailableToInvest()"
            ></app-indian-currency-formatter>
          </span>
        </div>
        <span class="text-btn" (click)="onAddMoneyToWallet()">
          <strong>Add Money to Wallet</strong>
        </span>
      </div>
      <div class="product-details">
        <form [formGroup]="productsFormGroup">
          <div class="input-wrap" formArrayName="products">
            <div *ngFor="let product of productNameArray;let i=index;" class="input-box-wrap">
              <div class="input-box" [formGroupName]="i">
                  <label class="input-label fade-label">{{product.name}} - Amount </label>
                  <input class="input-field" (keypress)="disableAnySymbols($event)" type="number" min=0 placeholder="Amount" formControlName="investmentAmount" step="1000" />
                  <ng-container *ngIf="product.maturity_days; else no_maturity_days">
                    <div class="note">Maturity 
                        <app-tooltip class="tooltip-section" placement="bottom">
                            <i class="infoIcon material-icons" trigger>info_outline</i>
                            <div class="tooltip-max" content>
                                <strong class="text-black">Maturity</strong> 
                                months is the period during which the 
                                <strong class="text-black">finzyFLEX</strong> 
                                investments cannot be withdrawn to bank account.
                            </div>
                        </app-tooltip>
                        <strong class="note-strong">&nbsp;&nbsp;{{product.mhp}}m</strong>
                    </div>
                </ng-container>
                <ng-template #no_maturity_days>
                  <div class="note upper-note">MHP 
                    <app-tooltip class="tooltip-section" placement="bottom">
                      <i class="infoIcon material-icons" trigger>info_outline</i>
                      <div class="tooltip-max" content>
                        Minimum Holding Period (<strong class="text-black">MHP</strong>) 
                        is the period of months during which the 
                        <strong class="text-black">finzyFLEX</strong> investments cannot be withdrawn to bank account.
                      </div>
                    </app-tooltip><strong class="note-strong">&nbsp;&nbsp;{{product.mhp}}m</strong>
                  </div>
                </ng-template>
                <ng-container *ngIf="product.maturity_days; else default_interest_text">
                  <div class="note line-height-normal">Interest:<strong class="note-strong">&nbsp;&nbsp;upto {{product.roi}}% p.a. (20% for 18 months)</strong></div>
                </ng-container>
                <ng-template #default_interest_text>
                  <div class="note line-height-normal">Interest:<strong class="note-strong">&nbsp;&nbsp;upto {{product.roi}}% p.a.</strong></div>
                </ng-template>
              </div>
              <div class="individual-product-error" *ngIf="productsFormGroup.controls.products.controls[i].invalid">
                <div *ngIf="productsFormGroup.controls.products.controls[i].controls.investmentAmount.errors?.min">
                  <span class="error-info">The minimum amount should be {{productsFormGroup.controls.products.controls[i].controls.investmentAmount.errors?.min.min}}</span>
                </div>
                <div *ngIf="productsFormGroup.controls.products.controls[i].controls.investmentAmount.errors?.max">
                  <span class="error-info">The maximum amount should be {{productsFormGroup.controls.products.controls[i].controls.investmentAmount.errors?.max.max}}</span>
                </div>
              </div>
            </div>   
          </div>
          <div class="error-wrap" *ngIf="productsFormGroup.get('products').invalid && productsFormGroup.get('products').dirty && productsFormGroup.get('products').touched">
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'walletAmountExceededError'">
              <span class="error-info">Allocation Amount is Higher than the wallet amount, please <strong>add money</strong> or <strong>change the allocation.</strong></span>
            </div>
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'negativeNumberError'">
              <span class="error-info">Input fields must contain positive value</span>
            </div>
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'fieldEmptyError'">
              <span class="error-info">Any one fields must have positive value.</span>
            </div>
            <div class="error-block" *ngIf="
            isMultipleOfThousandError &&
            (productsFormGroup.get('products').errors?.error != 'firstPortfolioError') && 
            (productsFormGroup.get('products').errors?.error != 'notFirstPortfolioError')
            " >
                <span class="error-info">Investment amount must be a multiple of 1000.</span>
            </div>
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'notFirstPortfolioError'">
                <span class="error-info"> You can start investing with a minimum of  ₹{{postFundAllocationMinAmt}} and in multiples of ₹1,000 in one or multiple investment options.</span>
            </div>
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'firstPortfolioError'">
                <span class="error-info"> You can start investing with a minimum of  ₹{{initialFundAllocationMinAmt}} and in multiples of ₹1,000 in one or multiple investment options.</span>
            </div>
            <div class="error-block" *ngIf="productsFormGroup.get('products').errors?.error == 'investmentAmountExceededError'">
              <span class="error-info"> Investments across all the products total <b>₹{{maximumInvestmentAmount-maxInvestmentAmount | number : "1.0-2"}}</b>. The total investment amount <b>exceeds</b> the maximum investment amount of <b>₹50 lakhs</b>.</span>
          </div>
          </div>
          <div class="consent">
            <mat-checkbox style="display: inline; float: left; height: 20px;" formControlName="lenderExposureAcrossP2PPlatforms"></mat-checkbox>
            <span class="consent-info">
              &nbsp; I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P platforms in India, 
              including www.finzy.com and hereby undertake to inform finzy if my aggregate exposure from investing, across 
              all the P2P platforms in India, at any point of time is equivalent to ₹50,00,000, and understand and agree that 
              finzy shall be entitled to take any and all actions as it may deem fit.
              <br>
              I, hereby also agree that as and when my investment across all the P2P platforms in 
              India including www.finzy.com exceed <strong>₹10,00,000</strong>, I will provide finzy a 
              <strong><a [href]="getFileUrlByName('investorNetworthCertificate')"
                target="_blank" class="info-underline">net-worth certificate</a></strong> from a practicing Chartered Accountant
                in the attached format certifying that I have net-worth of more than <strong>₹50,00,000</strong>.
              <br>
              I, hereby also confirm that I have understood all the risks associated with the lending 
              transactions and finzy does not assure return of principal/payment of 
              interest and there exists a likelihood of loss of the entire principal 
              in case of default by a borrower.
              <br>
              I, hereby confirm the investor <strong><a href="/terms?selectedTab=Investor" target="_blank" class="info-underline">terms and conditions</a></strong>.
              <br>
              I, hereby confirm to review the loan agreement with borrower and BRIDGE FINTECH SOLUTIONS PRIVATE LIMITED (Finzy). Sample agreement can be downloaded from <strong>
                <a [href]="getFileUrlByName('masterLoanAggrement')" target="_blank" class="info-underline">here.</a>
              </strong>
            </span>
          </div>
          <div>
            <button *ngIf="!btnLoader" (click)="onSubmitToInvest(productsFormGroup)" 
            [disabled]=" (this.totalAmountInvested == 0) ||
              productsFormGroup.controls.lenderExposureAcrossP2PPlatforms.invalid 
              || isMultipleOfThousandError"
            class="invest-now-btn">
              <strong> Invest Now </strong>
            </button>
            <div *ngIf="btnLoader" class="loader">
              <mat-spinner [diameter]="35"></mat-spinner>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  